import React from 'react';
import {
  FormControl,
  FormHelperText,
  ListSubheader,
  MenuItem,
  Select as MuiSelect,
  styled,
} from '@mui/material';
import { SelectProps, StyledFormLabel } from '../Select/Select';

const StyledListSubheader = styled(ListSubheader)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[700],
  lineHeight: '30px',
}));

interface StateSelectorProps extends Omit<SelectProps, 'options'> {
  states: Array<{
    label: string;
    value: string;
  }>;
  territories?: Array<{
    label: string;
    value: string;
  }>;
  translation: (key: string) => string;
}

export const StateSelector = ({
  id,
  label,
  states,
  territories = [],
  error,
  helperText,
  translation,
  variant = 'outlined',
  ...rest
}: StateSelectorProps) => (
  // No need to search for headers in JSON data anymore
  <FormControl error={!!error} fullWidth>
    <StyledFormLabel id={`${id}-label`}>{label}</StyledFormLabel>
    <MuiSelect
      labelId={`${id}-label`}
      id={id}
      variant={variant}
      MenuProps={{ disableEnforceFocus: true }}
      {...rest}
    >
      {/* US States header - directly use translation */}
      {states.length > 0 && <StyledListSubheader>{translation('us_states')}</StyledListSubheader>}

      {/* List all states */}
      {states.map((state) => (
        <MenuItem key={state.value} value={state.value}>
          {state.label}
        </MenuItem>
      ))}

      {/* US Territories header - only show if we have territories */}
      {territories.length > 0 && (
        <StyledListSubheader>{translation('us_territories')}</StyledListSubheader>
      )}

      {/* List all territories */}
      {territories.map((territory) => (
        <MenuItem key={territory.value} value={territory.value}>
          {territory.label}
        </MenuItem>
      ))}
    </MuiSelect>
    {helperText && (
      <FormHelperText id={`${id}-helper-text`} error={!!error}>
        {helperText}
      </FormHelperText>
    )}
  </FormControl>
);
